import { memo, useEffect } from 'react'
import { fetchOrders } from 'actions/OrderActions'
import Chat from 'supportAssistant/components/Chat/Chat'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { areOrdersBeingFetched, haveOrdersBeenFetched } from 'lib/order/orderUtils'
import { selectLoggedIn } from 'selectors/accountSelectors'
import useChatListener from 'supportAssistant/hooks/useChatListeners'
import useChats from 'supportAssistant/hooks/useChats'
import { trackClientEvent } from 'analytics/analytics'

function ChatPage() {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const ordersFetched = useAppSelector(state => haveOrdersBeenFetched(state, 'upcoming'))
  const ordersFetching = useAppSelector(state => areOrdersBeingFetched(state, 'upcoming'))

  useChatListener()
  useChats()

  useEffect(() => {
    if (isLoggedIn && !ordersFetched && !ordersFetching) {
      dispatch(fetchOrders({ status: 'upcoming' }))
    }

    trackClientEvent({
      subject: 'support_assistant',
      action: 'lesa_v2_agentic_assistant',
      category: 'logging',
      type: 'operational',
      optimizelyEventId: '5338528582729728',
      optimizelyEventKey: 'lesa_v2_agentic_assistant',
    })
  }, [dispatch, isLoggedIn, ordersFetched, ordersFetching])

  return <Chat />
}

export default memo(ChatPage)
